import { ChannelType } from './channel-type.constants';
import { ContactType } from './contact-type.constants';
export enum OperationType {
  CONTACT_MOBILE_CREATE = 'contact_mobile_create',
  CONTACT_EMAIL_CREATE = 'contact_email_create',
  CONTACT_MOBILE_DELETE = 'contact_mobile_delete',
  CONTACT_EMAIL_DELETE = 'contact_email_delete',
  CONTACT_MOBILE_UPDATE = 'contact_mobile_update',
  CONTACT_MOBILE_UPDATE_2FA = 'contact_mobile_update_2fa',
  CONTACT_EMAIL_UPDATE = 'contact_email_update',
  CONTACT_EMAIL_UPDATE_2FA = 'contact_email_update_2fa',
  DEVICE_PAIRING = 'device_pairing',
  DEVICE_DELETE = 'device_delete',
  TWOFA_SMS_CREATE = '2fa_sms_create',
  TWOFA_SMS_DELETE = '2fa_sms_delete',
  PROGRAM_PASSWORD_REFRESH = 'program_password_refresh',
}

export const getCreateOperationType = (type: ContactType): OperationType =>
  type === ContactType.EMAIL ? OperationType.CONTACT_EMAIL_CREATE : OperationType.CONTACT_MOBILE_CREATE;

export const getDeleteOperationType = (type: ContactType): OperationType =>
  type === ContactType.EMAIL ? OperationType.CONTACT_EMAIL_DELETE : OperationType.CONTACT_MOBILE_DELETE;

export const getUpdateOperationType = (type: ContactType): OperationType =>
  type === ContactType.EMAIL ? OperationType.CONTACT_EMAIL_UPDATE : OperationType.CONTACT_MOBILE_UPDATE;

export const getUpdateOperationType2FA = (type: ContactType): OperationType =>
  type === ContactType.EMAIL ? OperationType.CONTACT_EMAIL_UPDATE_2FA : OperationType.CONTACT_MOBILE_UPDATE_2FA;

export const getChannelType = (type: ContactType): ChannelType =>
  type === ContactType.EMAIL ? ChannelType.EMAIL : ChannelType.SMS;
